module.exports = fox._r("images/events/new_year/snow_head.png", __webpack_public_path__ + "_/_/_/common/frame/images/events/new_year/snow_head.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/events/new_year/snow_head.png
// module id = 108
// module chunks = 2